(ns ycweb.app.website.dlp.widgets.mobilecarousel
  (:require
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.app.website.common :as web-common]
   [ycweb.util.core :as u]))

(rum/defc mobile-carousel < rum/reactive [app-atom _ {:keys [properties]}]
  (let [{:mobile-carousel/keys [slides]} properties]

    [:div.yc-slick-carousel-wrapper
     [:nav.js-category-carousel
      {:class (u/bem :category-slider [:no-overflow])}
      (map
        (fn [slide]
          (let [{:slides/keys
                 [slide-url bg-type picture-public-id image-alt-text
                  title mute-slide? slide-background-colour]} slide

                {:slide-background-colour/keys
                 [colour-name text-dark?]} slide-background-colour]
            (when-not (trf/toboolean mute-slide?)
              [:div.category-slider-item
               [:a.category-slider-item__link
                {:href (str slide-url "?ref=slider-carousel")}
                [:div
                 {:class (u/bem :category-slider-item__content [(when (= bg-type "colour") :no-image)] :card [:no-border])}
                 (when (= bg-type "image")
                   (web-common/lazy-image app-atom
                     picture-public-id
                     {:class ["yc-simple-image  yc-simple-image--full"]}
                     {:w 240
                      :mw 240
                      :q "auto"
                      :alt (or image-alt-text title)}))
                 [:div.category-slider__title-wrapper
                  {:class (when (= bg-type "colour") (str "u-bg-" colour-name))}
                  [:div.category-slider__title
                   {:class
                    (if (and text-dark? (not (= bg-type "image"))) "u-text-oil" "u-text-white")}
                   title]]]]])))
        slides)]]))